import React, { useMemo } from 'react';
import { LookupSelect, type LookupSelectProps } from './LookupSelect';
import { labelCountry } from './lookupHelpers';
import { compareByCountryName, useEndpointLookupOptions } from './useLookupOptions';

const ENDPOINT = '/countries?page=1&limit=2000';

function keepIdsKey(includeIds: LookupSelectProps['includeIds']): string {
  return (includeIds ?? [])
    .map((id: string | number | null | undefined) => (id == null || id === '' ? '' : String(id)))
    .filter(Boolean)
    .join(',');
}

/** Active countries, ordered by name. */
export function CountrySelect({ includeIds, ...props }: LookupSelectProps) {
  const keepKey = keepIdsKey(includeIds);
  const keepIds = useMemo(() => (keepKey ? keepKey.split(',') : undefined), [keepKey]);
  const { options, isLoading } = useEndpointLookupOptions({
    endpoint: ENDPOINT,
    getLabel: labelCountry,
    keepIds,
    compare: compareByCountryName,
  });
  return (
    <LookupSelect
      {...props}
      includeIds={includeIds}
      options={options}
      isLoading={isLoading}
      placeholder={props.placeholder ?? 'Select country…'}
      searchPlaceholder={props.searchPlaceholder ?? 'Search countries…'}
    />
  );
}

export default CountrySelect;
